import axios from 'axios'
import { FaqEntry } from './dtos/FaqEntry.schema'

export const getFaq = async (): Promise<FaqEntry[]> => {
  const res = await axios.get<FaqEntry[]>('/faq')
  return res.data
}

export const createFaq = async (faqEntry: FaqEntry): Promise<void> => {
  const res = await axios.post<FaqEntry[]>('/faq', faqEntry)
}

export const deleteFaq = async (id: number): Promise<void> => {
  const res = await axios.delete<FaqEntry[]>('/faq/' + id)
}
